import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends BaseService {

  constructor() {
    super();
  }
  getAllUserList(): Observable<any> {
    let url = APIUrl.userNameList;
    return this.httpService.get(url)
  }

  getAllMessages():Observable<any>{
    let url = APIUrl.allMessages;
    return this.httpService.get(url) 
  }
  getMessageByID(messageId:any):Observable<any>{
    let url: string= APIUrl.messageStatus;
    let params: any = new HttpParams().set('messageId', messageId)
    return this.httpService.getParams(url,params)
  }
  getMessageStatus(messageStatus: any):Observable<any>{
    let url: string = APIUrl.messageStatus;
    let params = new HttpParams().set('messageStatus', messageStatus)
    return this.httpService.getParams(url, params)
  }
  getReceivedMessages():Observable<any>{
    let url = APIUrl.receivedMessagegs;
    return this.httpService.get(url);
  }
  getSentMessages():Observable<any>{
    let url = APIUrl.sentMessages;
    return this.httpService.get(url);
  }
  getDeletedMessages():Observable<any>{
    let url = APIUrl.deletedMessages;
    return this.httpService.get(url);
  }
  attachment(formData): Observable<any> {
    return this.httpService.post(APIUrl.attachment , formData)
  }  

  deleteReceivedMessages(formData): Observable<any> {
    let url = APIUrl.deleteReceived;
    return this.httpService.post(url,formData)
  }
  deleteSentMessages(formData): Observable<any> {
    let url = APIUrl.deleteSent;
    return this.httpService.post(url, formData)
  }
  putMessageflag(id):Observable<any>{
    let url = `${APIUrl.messageflag}/${id}`;
    return this.httpService.put(url,{});
  }
  getAllSalesReps():Observable<any>{
    let url = `${APIUrl.salesrepsList}`
    return this.httpService.get(url);
  }
  sendMultipleRetailer(formData): Observable<any> {
    let url = APIUrl.messageMultipleRetailers;
    return this.httpService.post(url, formData)
  }

  markMessageRead(messageReciepentId: number): Observable<any> {
    let url = `${APIUrl.markMessagesRead}/${messageReciepentId}`
    return this.httpService.put(url, {});
  }
}


// String message;
// String attachment;
// Integer senderId;
// List < Integer > recipients;
// Boolean importantFlag;
// Integer respondMessageId;